module.exports = __webpack_public_path__ + "static/hospital_cash.23c57753.jpg";